import React, { useEffect } from 'react';

const emptyArray = [];

const AutoscalableInputsArray = ({ name, values, touched, errors, onChange, onBlur, ItemComponent, isItemEmpty, newItemValue }) => {
  if (!Array.isArray(values)) values = emptyArray;
  if (!Array.isArray(touched)) touched = emptyArray;
  if (!Array.isArray(errors)) errors = emptyArray;

  useEffect(() => {
    let newValues = values;
    if (newValues.length === 0) {
      newValues = [newItemValue];
    }

    if (!isItemEmpty(newValues[newValues.length - 1])) {
      newValues = [...newValues, newItemValue];
    }

    const toRemove = [];
    newValues.forEach((val, index) => {
      if (index !== newValues.length - 1 && isItemEmpty(newValues[index])) {
        toRemove.push(index);
      }
    });

    if (toRemove.length) {
      newValues = newValues.filter((val, index) => !toRemove.includes(index));
    }

    if (newValues !== values) onChange({ target: { name, value: newValues } });
  }, [isItemEmpty, name, newItemValue, onChange, values]);

  const renderComponent = (index) => {
    return (
      <ItemComponent
        key={index}
        name={`${name}.${index}`}
        values={values[index]}
        touched={touched[index]}
        errors={errors[index]}
        onChange={onChange}
        onBlur={onBlur}
      />
    );
  };

  return (<>{values.map((_, i) => renderComponent(i))}</>);
};

export default AutoscalableInputsArray;
